import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import workflowApi from "../../api/workflowApi";
import { toast } from "react-toastify";
import WorkflowTasksTabAll from "../../components/workflow/WorkflowTabAll";
import { confirmSubmit } from "../../utils/confirmSubmit";

export const WorkflowTasksPage = ({clients, workflowTemplates, onRefreshAccounts}) => {
    const [showCreateTask, setShowCreateTask] = useState(false);
     const [isLoader, setIsLoader] = useState(false);
    const token = useSelector((state) => state.auth.access_token);
    const userId = useSelector((state) => state.auth.userdetails.id);

    const [workflows, setWorkflows] = useState([]);
    const [workflowId, setWorkflowId] = useState(null);
   
    const [loading, setLoading] = useState(true);


    const [formData, setFormData] = useState({
        name: "",
        description:"",
        status:"TODO",
        category:"",
        template:"",
        account: "",
        assignedTo: "",
        createdBy: "",
        startDate:"",
        dueDate:""
    });

    useEffect(()=> {
        const today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);

        setFormData(prev => ({
            ...prev,
            startDate: today.toISOString().split("T")[0],
            dueDate: tomorrow.toISOString().split("T")[0],
            assignedTo: formData.assignedTo,
            createdBy: { id: userId },
        }));
    }, [userId]);

    const fetchWorkflows = async () => {
        try {
            setLoading(true);
            const response = await workflowApi.allWorkflow(undefined, token);
            setWorkflows(response?.data || []);
        } catch (error) {
            console.error("Error fetching workflows:", error);
        } finally {
            setLoading(false);
        }
    };



    // Delete workflow
    const handleDeleteWorkflowNew = async (workflowId) => {
            const confirmed = await confirmSubmit({
                              title: "Confirm workflow delete",
                              text: "Are you sure you want to delete this workflow?",
                              confirmText: "Submit",
                            });
            
                    if (!confirmed) return;            try {
                await workflowApi.deleteWorkflowNew(workflowId, token);
                toast.success("Workflow deleted successfully");
                fetchWorkflows();
                onRefreshAccounts();
            } catch (error) {
                console.error("❌ Error deleting workflow:", error);
                toast.error("Failed to delete workflow");
            }
    };

    useEffect(() => {
        fetchWorkflows();
    }, []);


    const [errors, setErrors] = useState({});
    const safeTrim = (value) => (value || "").trim();

    const validateForm = () => {
        const newErrors = {};

        if (!safeTrim(formData.name))
            newErrors.name = "Name is required";

        if (!formData.status)
            newErrors.status = "Status is required";
        if (!formData.account)
            newErrors.account = "Account is required";
        if (!formData.assignedTo)
            newErrors.assignedTo = "Assigned To is required";
        if (!formData.category)
            newErrors.category = "Category is required";
        if (!formData.template)
            newErrors.template = "Template is required";
        if (!formData.startDate)
            newErrors.startDate = "Start Date is required";
        if (!formData.dueDate)
            newErrors.dueDate = "Due Date is required";
        if (!formData.description)
            newErrors.description = "Description is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
        };

        
        

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
                toast.error("Please fill all required fields correctly.");
                setIsLoader(false);
                return;
            }
        const payload = {
            name: formData?.name,
            description: formData?.description,
            status: formData?.status,
            category: formData?.category,
            template: formData?.template,
            accountId: formData?.account ,
            assignedToId:  formData?.assignedTo,
            createdBy: formData?.createdBy,
            startDate: formData?.startDate,
            dueDate: formData?.dueDate
        };

        // console.log("Workflow request payload menu:", payload);

        try {
            setIsLoader(true);
            if (workflowId) {
                // console.log("Workflow updated request payload:", payload)
                await workflowApi.updateWorkflow(workflowId, payload, token);
                // console.log("Workflow update response:", response);
                setIsLoader(false);
                toast.success("Workflow update successfully!");
                setShowCreateTask(false);
                fetchWorkflows();
                onRefreshAccounts();
                setFormData({
                    name: "",
                    description:"",
                    status:"TODO",
                    category:"",
                    template:"",
                    account: "",
                });
                setWorkflowId(null);
            }else{
               await workflowApi.createWorkflow(payload, token);
                // console.log("Workflow create response:", response);
                setIsLoader(false);
                toast.success("Workflow created successfully!");
                setShowCreateTask(false);
                fetchWorkflows();
                onRefreshAccounts();
                setWorkflowId(null);
                setFormData({
                    name: "",
                    description:"",
                    status:"TODO",
                    category:"",
                    template:"",
                    account: "",
                });
            }
        } catch (error) {
            console.error("Error creating workflow:", error);
            // toast.error(error);
            setIsLoader(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 p-0">
            <div>
                <WorkflowTasksTabAll
                    allTasks={workflows}
                    workflowTemplates={workflowTemplates}
                    clients={clients}
                    formData={formData}
                    isLoader={isLoader}
                    showCreateTask={showCreateTask}
                    setShowCreateTask={setShowCreateTask}
                    setFormData={setFormData}
                    handleSubmit={handleSubmit}
                    handleDeleteTask={handleDeleteWorkflowNew}
                    workflowId={workflowId}
                    setWorkflowId={setWorkflowId}
                    onRefreshAccounts={onRefreshAccounts}
                    fetchWorkflows={fetchWorkflows}
                    heading={`${workflows.length} ${workflows.length === 1 ? 'Workflow' : 'Workflows'}`}
                    type={"workflow"}
                    errors={errors}
                />
                
    
            </div>
        </div>
    );
};